window.addEventListener("DOMContentLoaded", () => {
	const animatedItems = document.querySelectorAll(".timeline-item");

	if (!animatedItems.length) {
		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add("is-visible");
					observer.unobserve(entry.target);
				}
			});
		},
		{
			threshold: 0.1,
		},
	);

	animatedItems.forEach((item) => {
		observer.observe(item);
	});
});
